<nz-modal [nzVisible]="true" (nzOnCancel)="handleCancel()" [nzClosable]="true" [nzStyle]="{ top: 0, padding: 0 }"
    [nzBodyStyle]="{ padding: '0', height: '75vh' }" [nzCentered]="true"
    [nzMaskStyle]="{ backgroundColor: 'rgba(0,0,0,0.45)' }" [nzTitle]="titleTemplate" [nzWidth]="'100%'"
    nzClassName="full-screen-modal">
    <ng-container *nzModalContent nzClassName="content">
        <div *ngIf="page === 0">
            <div class="brand-select-body-wrapper mt-2">
                <nz-table #nzTable class="premium-table mb-1" [nzData]="listOfCurrentPageData"
                    [nzScroll]="{ y: 'calc(100vh - 220px)' }" [nzFrontPagination]="false" [nzShowPagination]="false"
                    [nzLoading]="loadingListData" [nzTableLayout]="'fixed'" [nzSize]="'middle'" [nzBordered]="false"
                    [nzRowSelection]="{
                    type: 'checkbox',
                    selectedRowKeys: selectedBrandKeyList,
                    onChange: onRowSelectionChange
                    }">
                    <thead>
                        <tr>
                            <th [nzSelections]="listOfSelection" [nzChecked]="checked" [nzIndeterminate]="indeterminate"
                                (nzCheckedChange)="onAllChecked($event)" nzWidth="30px"
                                [nzDisabled]="listOfCurrentPageData?.length === disableBrandsSelections"></th>
                            <th nzWidth="150px" [nzShowSort]="true" (nzSortOrderChange)="sort('Name', $event)">Brand
                            </th>
                            <th nzWidth="175px" [nzShowSort]="true" (nzSortOrderChange)="sort('RenewalDate', $event)">
                                Current Renewal Date</th>
                            <th nzWidth="150px" nzAlign="right" class="pr-2">12-Month Price</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="!loadingListData">
                        <!-- <tr>
                            <td [colSpan]="4"></td>
                        </tr> -->
                        <ng-container *ngFor="let data of nzTable.data">
                            <tr [nzSelected]="setOfCheckedId.has(data.id)"
                                (click)="data.isSameAsConsolidate ? null : onBrandRowClick(data)" class="premiumParent">
                                <td [nzChecked]="setOfCheckedId.has(data.id)"
                                    (nzCheckedChange)="onItemChecked(data.id, $event)" nzWidth="30px"></td>
                                <td class="fw-bold">{{ data.name }}</td>
                                <td class="fw-bold">{{ data.renewalDate.toString().slice(0,-1) | date:'longDate' }}</td>
                                <td nzAlign="right" class="fw-bold pr-2">{{ data.brandAmount | currency }}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                    <tbody *ngIf="loadingListData">
                        <tr *ngFor="let i of [].constructor(15)">
                            <ng-container *ngFor="let i of [].constructor(4)">
                                <td [nzAlign]="'left'" class="loading">
                                    <div class="bar"></div>
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>

        <div *ngIf="page === 1">
            <div class="table-wrapper mt-2">
                <!-- floating label goes here -->
                <div class="consolidateRenewalDateTitle" [style.left.px]="discountHeaderLeft" [style.top.px]="-35">
                    CONSOLIDATE RENEWAL DATE
                    <div class="nextYearDate">
                        {{consolidateRenewalDate | date: 'longDate':'UTC'}}
                    </div>
                </div>
                <div class="brand-select-body-wrapper">
                    <nz-table #nzTable class="premium-table" [nzData]="tableData"
                        [nzScroll]="{ y: 'calc(100vh - 220px)' }" [nzFrontPagination]="false" [nzShowPagination]="false"
                        [nzTableLayout]="'fixed'" [nzSize]="'middle'" [nzBordered]="false" [nzRowSelection]="{
                    type: 'checkbox',
                    selectedRowKeys: selectedBrandKeyList,
                    onChange: onRowSelectionChange
                    }">
                        <thead>
                            <tr class="table-header">
                                <th nzWidth="150px">Brand</th>
                                <!-- <th nzWidth="150px">Product</th> -->
                                <th nzWidth="150px">Current Renewal date</th>
                                <th nzWidth="150px" nzAlign="right" class="pr-2">12-month price</th>
                                <th #proratedDiscountHeader nzWidth="150px" nzAlign="right">Prorated discount</th>
                                <th nzWidth="150px" nzAlign="right" class="pr-50">Prorated price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <div class="consolidateRenewalTableBody"></div>
                            <ng-container *ngFor="let data of nzTable.data">
                                <tr [nzSelected]="setOfCheckedId.has(data.id)" class="premiumParent"
                                    [ngClass]="{'disable-row': data.isRenewalDateMoreThan11Months}" nz-tooltip
                                    [nzTooltipTitle]="data.isRenewalDateMoreThan11Months ? 'This brand cannot be selected as its renewal date is more than 11 months from the consolidate renewal date.' : ''"
                                    nzTooltipPlacement="bottom">
                                    <td class="fw-bold">{{ data.name }}</td>
                                    <td class="fw-bold">{{ data.renewalDate.toString().slice(0,-1) |
                                        date:'longDate':'UTC'}}</td>
                                    <td class="fw-bold" nzAlign="right" class="pr-2">
                                        <span nz-typography *ngIf="data.isRenewalDateMoreThan11Months;">
                                            <del>{{data.brandAmount | currency}}</del>
                                        </span>
                                        <span *ngIf="!data.isRenewalDateMoreThan11Months;">
                                            {{data.brandAmount | currency}}
                                        </span>
                                    </td>
                                    <td nzAlign="right" class="fw-bold">
                                        <span nz-typography *ngIf="data.isRenewalDateMoreThan11Months; else noDiscount">
                                            <del>{{ (data.proratedDiscount > 0 ?
                                                -data.proratedDiscount : data.proratedDiscount) | currency }}</del>

                                        </span>
                                        <ng-template #noDiscount>
                                            {{ (data.proratedDiscount > 0 ?
                                            -data.proratedDiscount : data.proratedDiscount) | currency }}
                                        </ng-template>
                                    </td>
                                    <td nzAlign="right" class="fw-bold pr-50">
                                        <span nz-typography *ngIf="data.isRenewalDateMoreThan11Months;">
                                            <del>{{ data.proratedPrice | currency }}</del>
                                        </span>
                                        <span *ngIf="!data.isRenewalDateMoreThan11Months;">
                                            {{ data.proratedPrice | currency }}
                                        </span>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </nz-table>
                </div>
            </div>
        </div>

        <div *ngIf="page === 2">
            <div class="brand-select-body-wrapper mt-2">
                <nz-table #nzTable class="premium-table mt-2" [nzData]="tableData"
                    [nzScroll]="{ y: 'calc(100vh - 220px)' }" [nzFrontPagination]="false" [nzShowPagination]="false"
                    [nzTableLayout]="'fixed'" [nzSize]="'middle'" [nzBordered]="false" [nzRowSelection]="{
                    type: 'checkbox',
                    selectedRowKeys: selectedBrandKeyList,
                    onChange: onRowSelectionChange
                    }">
                    <thead>
                        <tr class="table-header">
                            <th nzWidth="150px">Brand</th>
                            <th nzWidth="100px">Estimated Renewal date</th>
                            <th nzWidth="70px"></th>
                            <th nzWidth="120px" nzAlign="right" class="pr-50">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let data of nzTable.data">
                            <tr [nzSelected]="setOfCheckedId.has(data.id)" class="premiumParent">
                                <td class="fw-bold">{{ data.name }}</td>
                                <td class="fw-bold">{{ (isDifferentRenewalMonthsForBrands ? consolidateRenewalDate :
                                    data.newRenewalDate) | date:'longDate'}}</td>
                                <td nzAlign="center"><span class="prorated-tag"
                                        *ngIf="data.proratedDiscount > 0">PRORATED</span></td>
                                <td nzAlign="right" class="fw-bold pr-50">{{ data.proratedPrice | currency }}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </nz-table>
            </div>
        </div>

        <div *ngIf="page === 3">
            <div class="request-invoice-body-wrapper">
                <div class="form-container">
                    <!-- Company Information Section -->
                    <nz-skeleton *ngIf="!companyDetails"></nz-skeleton>
                    <div class="company-section" *ngIf="companyDetails">
                        <div class="company-title">{{companyDetails.name || ''}}</div>
                        <div>{{companyDetails.address1 || ''}}</div>
                        <div>{{companyDetails.address2 || ''}}</div>
                        <div>
                            {{companyDetails.city ? companyDetails.city : ''}} {{companyDetails.city &&
                            companyDetails.state ? ', ' : ''}}
                            {{companyDetails.state ? companyDetails.state : ''}} {{companyDetails.state &&
                            companyDetails.zip ? ' ' : ''}}
                            {{companyDetails.zip ? (companyDetails.zip | mask: '00000-0000') : ''}}</div>
                        <div>{{companyDetails.country || ''}}</div>
                    </div>
                    <form nz-form [formGroup]="_fS.retailProgramInvestmentForm">
                        <!-- Supplier Rep Section -->
                        <div class="supplier-row mt-3">
                            <div style="flex: 1;">
                                <nz-form-item>
                                    <nz-form-control [nzErrorTip]="investorError">
                                        <label class="label-text required">Supplier Rep</label>
                                        <nz-select nzShowSearch nzPlaceHolder="Select Rep" [nzSize]="'default'"
                                            class="h-45" formControlName="rep" [nzSelectOnTab]="true">
                                            <ng-container *ngFor="let option of listOfReps">
                                                <!-- (ngModelChange)="getInvestorTerms($event);getInvestorDetails($event)" -->
                                                <nz-option *ngIf="!isLoading" [nzValue]="option.id"
                                                    [nzLabel]="option.name + ' | '+ option.email">
                                                </nz-option>
                                            </ng-container>
                                            <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
                                                <span nz-icon nzType="loading" class="loading-icon"></span>
                                                Loading Data...
                                            </nz-option>
                                        </nz-select>
                                        <ng-template #investorError let-control>
                                            <ng-container *ngIf="control.hasError('required')">Please select
                                                rep</ng-container>
                                        </ng-template>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>

                            <div style="margin-top: 24px;">
                                <button nz-button nzType="default" (click)="openNewRepModal()">
                                    New Rep
                                </button>
                            </div>

                            <div class="amount-section">
                                <div class="amount-label">Amount to Pay</div>
                                <div class="amount-value">{{amountToPay | currency}}</div>
                            </div>
                        </div>

                        <!-- Invoice Description Section -->
                        <nz-form-item>
                            <nz-form-control>
                                <label class="label-text">Invoice Description</label>
                                <div class="retailProgramDescriptionTitle">
                                    {{programDetail?.name + " Premium Content"}}
                                </div>
                                <div class="description-box">
                                    <textarea nz-input formControlName="detailedDescription" rows="3"
                                        placeholder="Enter description...">
                                    </textarea>
                                </div>
                            </nz-form-control>
                        </nz-form-item>

                        <!-- Accounting Notes Section -->
                        <nz-form-item>
                            <nz-form-control>
                                <label class="label-text">Accounting Notes</label>
                                <!-- (keydown)="preventEnter($event)" -->
                                <textarea type="text" nz-input formControlName="accountingNotes"
                                    placeholder="Add notes here" rows="2" maxlength="1000"></textarea>
                            </nz-form-control>
                        </nz-form-item>

                        <!-- Agreement Checkbox -->
                        <nz-form-item>
                            <nz-form-control>
                                <div class="d-flex align-flex-start">
                                    <label nz-checkbox formControlName="isAgreed" class="pr-1"></label>
                                    <div>
                                        <label class="required"></label>
                                    </div>
                                    <span class="checkbox-content cursor"
                                        (click)="_fS.retailProgramInvestmentForm.get('isAgreed').patchValue(!_fS.retailProgramInvestmentForm.get('isAgreed').value)">
                                        <!-- <span class="required"></span> -->
                                        An invoice will be emailed to the Supplier rep selected above within 1 business
                                        day. Wine.com Premium
                                        Marketing will not be turned on until
                                        payment has been received. Payment options will be stated on the invoice. If you
                                        have any questions prior to submitting
                                        this invoice, please send us an email at
                                        <a href="mailto:wine.com-support@imiagency.com"
                                            class="support-link">{{'wine.com-support@imiagency.com'}}</a>
                                    </span>
                                </div>
                            </nz-form-control>
                        </nz-form-item>
                    </form>
                </div>
            </div>
        </div>
    </ng-container>
    <div *nzModalFooter>
        <div class="footer-wrapper">
            <button class="default-btn" nz-button (click)="page == 0 ? handleCancel() : handleGoBack()">{{page == 0 ?
                "Cancel" :
                "Back"}}</button>
            <button *ngIf="page === 0 || page === 1 || page === 2" nz-button (click)="handleOk(page+1)">Next </button>
            <button *ngIf="page === 3" nz-button (click)="renewInvestment()"
                [nzLoading]="investmentLoading">Submit</button>
        </div>
    </div>
</nz-modal>


<nz-drawer [nzVisible]="showInvestorModal" (nzOnClose)="handleCancelInvestor()" [nzTitle]="'New Investor'"
    [nzWidth]="800" [nzMaskClosable]="false" nzClassName="investorModal investor-modal-box-main">
    <div *nzDrawerContent>
        <div class="">
            <h4 class="modal-sub-title pt-20">Create New Rep for {{supplierDetails?.investorDisplayName}}</h4>
        </div>
        <app-add-investor-form [IsDrawer]="true" [existingReps]="listOfReps" (investorData)="newCreatedInvestor($event)"
            [ParentCompanyDetails]="companyDetails"></app-add-investor-form>
    </div>
</nz-drawer>


<ng-template #titleTemplate>
    <div nz-row style="align-items: center;">
        <div nz-col [nzSpan]="6">
            <span class="Investment-modal-status ml-1" style="font-size: 130%;">
                Renew Premium Content
            </span>
        </div>
        <div nz-col [nzSpan]="14">
            <nz-steps [nzCurrent]="progressBar" nzProgressDot>
                <nz-step nzTitle="Select Brands"></nz-step>
                <nz-step nzTitle="Consolidate Renewal" *ngIf="isDifferentRenewalMonthsForBrands"></nz-step>
                <nz-step nzTitle="Review Brands"></nz-step>
                <nz-step nzTitle="Request Invoice"></nz-step>
            </nz-steps>
        </div>
    </div>
</ng-template>

<nz-modal [nzVisible]="isVisibleInfoModal" (nzOnCancel)="isVisibleInfoModal = false" [nzClosable]="true"
    [nzCentered]="true" [nzFooter]="null" [nzMaskClosable]="false" [nzBodyStyle]="{ padding: '25px', height: '230px' }"
    [nzTitle]="null" [nzWidth]="'30%'">
    <ng-container *nzModalContent nzClassName="content">
        <div class="d-flex align-i-c justify-content-center h-100">
            <div>
                <div class="page-title-text center">Consolidating Renewal Dates</div>
                <div class="center pt-20 fs-18">Selecting multiple brands with different renewal dates will create a
                    consolidated renewal date with pro-rated pricing.</div>
            </div>
        </div>
    </ng-container>
</nz-modal>